import React, { useEffect, useState } from 'react';
import moment from 'moment';
import momenttimezone from 'moment-timezone';

function useTenderSchedule(tenderData) {
  const [timeRemaining, setTimeRemaining] = useState('');
  const [isBeforeSubmission, setIsBeforeSubmission] = useState(false);
  const [isAfterSubmission, setIsAfterSubmission] = useState(false);
  const [isBeforePublication, setIsBeforePublication] = useState(false);
  const [isAfterPublication, setIsAfterPublication] = useState(false);
  const [isAfterQueryDeadline, setIsAfterQueryDeadline] = useState(false);
  const [localPublicationDateTime, setLocalPublicationDateTime] = useState('');
  const [localSubmissionDateTime, setLocalSubmissionDateTime] = useState('');
  const [localQueryDeadlineDateTime, setLocalQueryDeadlineDateTime] =
    useState('');

  useEffect(() => {
    if (tenderData?.submissionDate && tenderData?.publicationDate) {
      const publicationDate = moment(tenderData?.publicationDate).format(
        'YYYY-MM-DD'
      );
      const submissionDate = moment(tenderData?.submissionDate).format(
        'YYYY-MM-DD'
      );

      const queryDeadline = moment(tenderData?.deadlineForQueries).format(
        'YYYY-MM-DD'
      );

      const publicationDateTime = momenttimezone.tz(
        `${publicationDate} ${tenderData?.publicationTime}`,
        tenderData?.publicationTimeZone
      );
      //.utc();
      const submissionDateTime = momenttimezone.tz(
        `${submissionDate} ${tenderData?.submissionTime}`,
        tenderData?.submissionTimeZone
      );
      //.utc();

      const queryDeadlineTime = momenttimezone.tz(
        `${queryDeadline} ${tenderData?.submissionTime}`,
        tenderData?.submissionTimeZone
      );

      const clientTimeZone = momenttimezone.tz.guess();

      // Convert the stored UTC time back to the client's local time
      const clientPublicationLocalTime = publicationDateTime
        .clone()
        .tz(clientTimeZone);
      const clientSubmissionLocalTime = submissionDateTime
        .clone()
        .tz(clientTimeZone);

      const clientQueryDeadlineLocalTime = queryDeadlineTime
        .clone()
        .tz(clientTimeZone);

      const localTime = moment().format('YYYY-MM-DD hh-mm-ss');

      setIsBeforeSubmission(moment(clientSubmissionLocalTime).isBefore());
      setIsAfterSubmission(moment(clientSubmissionLocalTime).isAfter());
      setIsBeforePublication(moment(clientPublicationLocalTime).isBefore());
      setIsAfterPublication(moment(clientPublicationLocalTime).isAfter());
      setIsAfterQueryDeadline(moment(clientQueryDeadlineLocalTime).isAfter());

      setLocalPublicationDateTime(
        moment(clientPublicationLocalTime).format('YYYY-MM-DD <---> hh:mm:ss a')
      );
      setLocalSubmissionDateTime(
        moment(clientSubmissionLocalTime).format('YYYY-MM-DD <---> hh:mm:ss a')
      );
      setLocalQueryDeadlineDateTime(
        moment(clientQueryDeadlineLocalTime).format(
          'YYYY-MM-DD <---> hh:mm:ss a'
        )
      );

      ////////////////////////

      /////////////////////////
      const interval = setInterval(() => {
        if (moment(clientPublicationLocalTime).isAfter()) {
          const now = moment();
          const duration = moment.duration(
            moment(clientPublicationLocalTime).diff(now)
          );
          const hours = Math.floor(duration.asHours())
            .toString()
            .padStart(2, '0');
          const minutes = duration.minutes().toString().padStart(2, '0');
          const seconds = duration.seconds().toString().padStart(2, '0');

          setTimeRemaining(
            `Starts in ${hours} h :  ${minutes} m : ${seconds} s`
          );
        } else if (moment(clientSubmissionLocalTime).isBefore()) {
          const now = moment();
          const duration = moment.duration(
            moment(clientSubmissionLocalTime).diff(now)
          );
          const hours = Math.floor(duration.asHours())
            .toString()
            .padStart(2, '0');
          const minutes = duration.minutes().toString().padStart(2, '0');
          const seconds = duration.seconds().toString().padStart(2, '0');

          setTimeRemaining(
            `Ended before ${hours} h :  ${minutes} m : ${seconds} s`
          );
        } else {
          const now = moment();
          const duration = moment.duration(
            moment(clientSubmissionLocalTime).diff(now)
          );
          const hours = Math.floor(duration.asHours())
            .toString()
            .padStart(2, '0');
          const minutes = duration.minutes().toString().padStart(2, '0');
          const seconds = duration.seconds().toString().padStart(2, '0');

          setTimeRemaining(`Ends in ${hours} h :  ${minutes} m : ${seconds} s`);
        }
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [tenderData?.submissionTime]);

  return {
    timeRemaining,
    isBeforeSubmission,
    isAfterSubmission,
    isBeforePublication,
    isAfterPublication,
    isAfterQueryDeadline,
    localPublicationDateTime,
    localSubmissionDateTime,
    localQueryDeadlineDateTime,
  };
}

export default useTenderSchedule;
